PluginEventEmitter = function () {};
heir.inherit(PluginEventEmitter, AppEventEmitter);
// noinspection JSCheckFunctionSignatures
PluginEventEmitter.prototype.addListener = function (evt, listener) {
    AppEventEmitter.prototype.addListener.call(this, evt, listener);
};
// noinspection JSCheckFunctionSignatures
PluginEventEmitter.prototype.emitEvent = function (evt, args) {
    AppEventEmitter.prototype.emitEvent.call(this, evt, [ args ]);
};

app.plugin = new PluginEventEmitter();
app.plugin.AUTOSIZE_INIT = 'autosize_init';
app.plugin.AUTOSIZE_UPDATE = 'autosize_update';
app.plugin.BS_BUTTON_CHECKBOX_INIT = 'bs_button_checkbox_init';
app.plugin.BS_DATERANGEPICKER_INIT = 'bs_daterangepicker_init';
app.plugin.BS_DATERANGEPICKER_CHANGE = 'bs_daterangepicker_change';
app.plugin.BS_FILESTYLE_INIT = 'bs_filestyle_init';
app.plugin.BS_FILESTYLE_UPLOADED = 'bs_filestyle_uploaded';
app.plugin.BS_POPOVER_INIT = 'bs_popover_init';
app.plugin.BS_POPOVER_HIDE = 'bs_popover_hide';
// app.plugin.BS_SELECT_INIT = 'bs_select_init';
// app.plugin.BS_SELECT_REFRESH = 'bs_select_refresh';
app.plugin.BS_SWITCH_INIT = 'bs_switch_init';
app.plugin.BS_SWITCH_CHANGE = 'bs_switch_change';
app.plugin.BS_TAB_INIT = 'bs_tab_init';
app.plugin.BS_TAB_SET_ACTIVE = 'bs_tab_set_active';
app.plugin.BS_TAB_SHOW = 'bs_tab_show';
app.plugin.BS_TAB_SHOWN = 'bs_tab_shown';
app.plugin.BS_TAB_HIDE = 'bs_tab_hide';
app.plugin.BS_TAB_HIDDEN = 'bs_tab_hidden';
app.plugin.BS_TOOLTIP_INIT = 'bs_tooltip_init';
app.plugin.BREAKPOINT_ENTER = 'breakpoint_enter';
app.plugin.BREAKPOINT_LEAVE = 'breakpoint_leave';
app.plugin.MODAL_CLOSE = 'modal_hide';
app.plugin.NOTY_SHOW = 'noty_show';
app.plugin.NOTY_CLOSE_ALL = 'noty_close_all';
app.plugin.NOTY_ON_SHOW = 'noty_on_show';
app.plugin.NOTY_AFTER_SHOW = 'noty_after_show';
app.plugin.NOTY_ON_CLOSE = 'noty_on_close';
app.plugin.NOTY_AFTER_CLOSE = 'noty_after_close';
app.plugin.NPROGRESS_START = 'nprogress_start';
app.plugin.NPROGRESS_DONE = 'nprogress_done';
// app.plugin.POPUP_CLOSE = 'popup_close';
app.plugin.SEARCH_INIT = 'search.init';
app.plugin.SEARCH_SELECT2_INIT = 'search_select2.init';
app.plugin.SELECT2_INIT = 'select2_init';
app.plugin.TEXTCOMPLETE_INIT = 'textcomplete_init';
app.plugin.TYPEAHEAD_JS_INIT = 'typeahead_js_init';
app.plugin.UI_BLOCK = 'ui_block';
app.plugin.UI_UNBLOCK = 'ui_unblock';

app.plugin.on(app.plugin.AUTOSIZE_INIT, function () {
    if (typeof autosize === 'function') {
        $('textarea.autosize').each(function () {
            if (typeof $(this).data('autosize') === 'undefined') {
                autosize($(this).css('height', '').css('overflow', '').data('autosize', true));
            }
        });
    }
});

app.plugin.on(app.plugin.AUTOSIZE_UPDATE, function (plugin) {
    if (typeof autosize === 'function') {
        autosize.update(plugin.e);
    }
});

app.plugin.on(app.plugin.BS_BUTTON_CHECKBOX_INIT, function () {
    $('.button-checkbox').each(function () {
        var $button = $(this).find('button');
        if ($button.data('bs.button.checkbox')) {
            return;
        } else {
            $button.data('bs.button.checkbox', 1);
        }
        var $checkbox = $(this).find('input:checkbox');
        $(this).on('click', function () {
            $checkbox.prop('checked', !$checkbox.is(':checked')).trigger('change');
            updateDisplay();
        });
        $checkbox.on('change', function () {
            updateDisplay();
        });
        function updateDisplay() {
            if ($checkbox.prop('checked')) {
                $button.addClass($button.data('checked-class') ? $button.data('checked-class') : 'btn-primary')
                    .removeClass('btn-default btn-light');
                $button.find('i').removeClass().addClass('fa fa-check-square-o fa-fw');
            } else {
                $button.removeClass($button.data('checked-class') ? $button.data('checked-class') : 'btn-primary')
                    .addClass('btn-default btn-light');
                $button.find('i').removeClass().addClass('fa fa-square-o fa-fw');
            }
        }
        (function () {
            updateDisplay();
        })();
    });
});

app.plugin.on(app.plugin.BS_DATERANGEPICKER_INIT, function (plugin) {
    var minDate = window.moment('2013-01-01');
    var maxDate = window.moment().endOf('year');
    var startDate = minDate;
    var endDate = maxDate;
    if ($(plugin.e).val()) {
        var range = $(plugin.e).val().split(' - ');
        if (range.length) {
            startDate = window.moment(range[0], 'MM/DD/YYYY');
            endDate = window.moment(range[1], 'MM/DD/YYYY');
        }
    }
    var singleDatePicker = plugin.e.data('single-date-picker');
    var options = {
        startDate: startDate,
        endDate: endDate,
        minDate: minDate,
        maxDate: maxDate,
        autoApply: singleDatePicker,
        singleDatePicker: singleDatePicker,
        showDropdowns: true,
        showWeekNumbers: true,
        linkedCalendars: false,
        autoUpdateInput: false,
        ranges: {
            'Today': [
                window.moment(),
                window.moment()
            ],
            'Yesterday': [
                window.moment().subtract(1, 'day'),
                window.moment().subtract(1, 'day')
            ],
            'Last 7 Days': [
                window.moment().subtract(6, 'days'),
                window.moment()
            ],
            'Last 30 Days': [
                window.moment().subtract(29, 'days'),
                window.moment()
            ],
            'This Week': [
                window.moment().startOf('isoWeek'),
                window.moment().endOf('isoWeek')
            ],
            'Last Week': [
                window.moment().subtract(1, 'week').startOf('isoWeek'),
                window.moment().subtract(1, 'week').endOf('isoWeek')
            ],
            'This Month': [
                window.moment().startOf('month'),
                window.moment().endOf('month')
            ],
            'Last Month': [
                window.moment().subtract(1, 'month').startOf('month'),
                window.moment().subtract(1, 'month').endOf('month')
            ],
            'This Year': [
                window.moment().startOf('year'),
                window.moment().endOf('year')
            ],
            'Last Year': [
                window.moment().subtract(1, 'year').startOf('year'),
                window.moment().subtract(1, 'year').endOf('year')
            ],
            'All Time': [
                minDate,
                maxDate
            ]
        },
        opens: 'left',
        buttonClasses: 'btn',
        applyClass: 'btn-primary'
    };
    if (singleDatePicker) {
        delete options.ranges;
    }
    $(plugin.e).daterangepicker($.extend(true, options, plugin.options), function (start, end, label) {
        if (this.startDate.isSame(this.minDate, 'day') && this.endDate.isSame(this.maxDate, 'day')) {
            $(plugin.e).val('');
        } else {
            if (singleDatePicker) {
                $(plugin.e).val(start.format('MM/DD/YYYY'));
            } else {
                $(plugin.e).val(start.format('MM/DD/YYYY') + ' - ' + end.format('MM/DD/YYYY'));
            }
        }
        $(plugin.e).trigger(app.plugin.BS_DATERANGEPICKER_CHANGE, {
            start: start,
            end: end,
            label: label
        });
    });
});

app.plugin.on(app.plugin.BS_FILESTYLE_INIT, function () {
    $('.bs-filestyle').each(function () {
        $(this).filestyle({
            placeholder: $(this).attr('data-placeholder')
        });
    });
});

app.plugin.on(app.plugin.BS_POPOVER_INIT, function () {
    $('body').on('click', '[data-bs-toggle="popover"]', function (event) {
        event.preventDefault();

        var el = $(this)[0];
        var instance = bootstrap.Popover.getInstance($(this)[0]);

        if (instance) {
            if ($(this).data('bs-disposable')) {
                instance.dispose();
            } else {
                instance.show();
            }
            return;
        }

        var popover = new bootstrap.Popover($(this)[0], {
            animation: false,
            container: (function () {
                if ($(this).attr('data-container')) {
                    if ($(this).attr('data-container') === ':next') {
                        return $(this).next();
                    }
                    if ($(document.body).children($(this).attr('data-container')).length === 0) {
                        var e = $('<div/>');
                        $(e).attr('id', $(this).attr('data-container').replace(/^#/, ''));
                        $(document.body).append(e);
                    }
                    return $(this).attr('data-container');
                } else {
                    return 'body';
                }
            }).call(this),
            content: $(this).attr('data-bs-content') || function () {
                if ($(this).attr('href') && '#' !== $(this).attr('href')) {
                    return $($(this).attr('href')).html();
                } else {
                    let e = $(this);
                    if (e.attr('data-bs-content-selector')) {
                        e = $(e.attr('data-bs-content-selector'));
                    }
                    if (e.attr('data-bs-content-base64')) {
                        return $(atob(e.attr('data-bs-content-base64')))[0];
                    } else {
                        return e.html();
                    }
                }
            },
            html: true,
            sanitize: false,
            template: (function () {
                return '' +
                '<div class="popover ' + ($(this).data('class') ? ' ' + $(this).data('class') : '') + '" role="tooltip">' +
                    '<div class="popover-arrow"></div>' +
                    '<h3 class="popover-header"></h3>' +
                    '<div class="popover-body"></div>' +
                '</div>';
            }).call(this),
            trigger: 'manual'
        });

        el.addEventListener('show.bs.popover', function (event) {
            app.popover.trigger($(event.target).data('name') || '*', app.popover.SHOW, {
                event: event
             });
        });
        el.addEventListener('shown.bs.popover', function (event) {
            app.popover.trigger($(event.target).data('name') || '*', app.popover.SHOWN, {
                event: event
            });
        });
        el.addEventListener('hide.bs.popover', function (event) {
            app.popover.trigger($(event.target).data('name') || '*', app.popover.HIDE, {
                event: event
            });
        });
        el.addEventListener('hidden.bs.popover', function (event) {
            app.popover.trigger($(event.target).data('name') || '*', app.popover.HIDDEN, {
                event: event
            });
        });
        el.addEventListener('inserted.bs.popover', function (event) {
            app.popover.trigger($(event.target).data('name') || '*', app.popover.INSERTED, {
                event: event
            });
        });

        popover.show();
    });
});

app.plugin.on(app.plugin.BS_POPOVER_HIDE, function () {
    $('[data-bs-toggle="popover"]').each(function () {
        var instance = bootstrap.Popover.getInstance($(this)[0]);
        if (instance) {
            instance.hide();
        }
    });
});

// app.plugin.on(app.plugin.BS_SELECT_INIT, function (plugin) {
//     $(plugin && plugin.e ? $(plugin.e) : $('select.selectpicker')).each(function () {
//         $(this).selectpicker($(this).data());
//     });
// });

// app.plugin.on(app.plugin.BS_SELECT_REFRESH, function (plugin) {
//     $(plugin.e).selectpicker('refresh');
// });

app.plugin.on(app.plugin.BS_SWITCH_INIT, function () {
    $('.bs-switch').each(function () {
        if (typeof $(this).data('bootstrapSwitch') === 'undefined') {
            $(this).bootstrapSwitch({ state: $(this).is(':checked') }).trigger('change').css('visibility', 'visible')
                .on('switchChange.bootstrapSwitch', function (event, state) {
                    app.plugin.trigger(app.plugin.BS_SWITCH_CHANGE, {
                        event: event,
                        state: state
                    });
            });
        }
    });
});
{
    app.plugin.on(app.plugin.BS_SWITCH_CHANGE, function (plugin) {
        $(plugin.event.target).trigger(app.plugin.BS_SWITCH_CHANGE, [ plugin.state ]);
    });
}

app.plugin.on(app.plugin.BS_TAB_INIT, function () {
    [].slice.call(document.querySelectorAll('.nav-tabs a[data-bs-toggle="tab"]')).forEach(function (el) {
        var instance = bootstrap.Tab.getInstance(el);
        if (instance) {
            return;
        }

        var tab = new bootstrap.Tab(el);

        el.addEventListener('click', function (event) {
            event.preventDefault();
            tab.show();
        });
        el.addEventListener('show.bs.tab', function (event) {
            app.plugin.trigger(app.plugin.BS_TAB_SHOW, {
                event: event
            });
        });
        el.addEventListener('shown.bs.tab', function (event) {
            app.plugin.trigger(app.plugin.BS_TAB_SHOWN, {
                event: event
            });
        });
        el.addEventListener('hide.bs.tab', function (event) {
            app.plugin.trigger(app.plugin.BS_TAB_HIDE, {
                event: event
            });
        });
        el.addEventListener('hidden.bs.tab', function (event) {
            app.plugin.trigger(app.plugin.BS_TAB_HIDDEN, {
                event: event
            });
        });
    });

    if (location.hash) {
        setTimeout(function () {
            var instance = bootstrap.Tab.getInstance($('a[href="#' + location.hash.substring(1) + '"]')[0]);
            if (instance) {
                instance.show();
            }
        }, 0);
    }
    if (!$('.nav-tabs > .nav-item > .nav-link.active').length) {
        var instance = bootstrap.Tab.getInstance($('.nav-tabs > .nav-item:first > .nav-link')[0]);
        if (instance) {
            instance.show();
        }
    }
    if (!$('.tab-content > div.active').length) {
        $('.tab-content > div:first').addClass('active');
    }
});

app.plugin.on(app.plugin.BS_TAB_SET_ACTIVE, function (plugin) {
    $(plugin.e).addClass('active').parent().siblings().find('.active').removeClass('active');
    $($(plugin.e).attr('href')).addClass('active').siblings('.active').removeClass('active');
});

app.plugin.on(app.plugin.BS_TAB_SHOW, function (plugin) {
    var widget = $(plugin.event.target).closest('.widget');
    if (widget.length) {
    //     widget.find('.btn-refresh').data('tab', $(plugin.event.target).data('name'));
    //     widget.find('.btn-pg-prev').data('tab', $(plugin.event.target).data('name'));
    //     widget.find('.btn-pg-next').data('tab', $(plugin.event.target).data('name'));
    //     widget.find('.search').data('tab', $(plugin.event.target).data('name'));
        app.btn.trigger($(widget).data('name'), app.btn.PG_PREV_UPDATE);
        app.btn.trigger($(widget).data('name'), app.btn.PG_NEXT_UPDATE);
    }
});

app.plugin.on(app.plugin.BS_TOOLTIP_INIT, function () {
    new bootstrap.Tooltip(document.body, {
        amimation: false,
        html: true,
        sanitizeFn: function (content) {
            return content;
        },
        selector: '[data-bs-toggle="tooltip"]'
    });
});

app.plugin.on(app.plugin.MODAL_CLOSE, function () {
    var $container = $('#container_modal');
    var key = $container.attr('data-last-key') || '';
    var name = $container.attr('data-last-name') || '';
    var type = $container.attr('data-last-type') || '';
    var id = name + (key ? '_key_' + key : '') + (type ? '_type_' + type : '');
    $container.removeAttr('data-last-key data-last-name data-last-type');
    $('#modal_' + id).modal('hide').css('z-index', 1050).find('.modal-body').html('');
});

Noty.overrideDefaults({
    callbacks: {
        onTemplate: function () {
            var type = ({
                'alert': 'primary',
                'error': 'danger',
                'information': 'info',
            })[this.options.type] ?? this.options.type;
            this.barDom.innerHTML = '<div class="noty_body alert bg-' + type + ' text-white mb-0">' +
                this.options.text +
            '</div>' +
            '<div class="noty_progressbar"></div>';
        }
    }
});

app.plugin.on(app.plugin.NOTY_SHOW, function (plugin) {
    new Noty($.extend(true, {
        layout: 'topRight',
        type: '',
        text: '',
        timeout: 3000,
        killer: true,
        callback: {
            onShow: function () {
                app.plugin.trigger(app.plugin.NOTY_ON_SHOW);
            },
            afterShow: function () {
                app.plugin.trigger(app.plugin.NOTY_AFTER_SHOW);
            },
            onClose: function () {
                app.plugin.trigger(app.plugin.NOTY_ON_CLOSE);
            },
            afterClose: function () {
                app.plugin.trigger(app.plugin.NOTY_AFTER_CLOSE);
            }
        }
    }, plugin, window['noty_defaults'] || {})).show();
});

app.plugin.on(app.plugin.NOTY_CLOSE_ALL, function () {
    Noty.closeAll();
});

app.plugin.on(app.plugin.NPROGRESS_START, function () {
    NProgress.start();
});
app.plugin.on(app.plugin.NPROGRESS_DONE, function () {
    NProgress.done();
});

// app.plugin.on(app.plugin.POPUP_CLOSE, function () {
//     $.magnificPopup.close();
// });

app.plugin.on(app.plugin.SEARCH_INIT, function (plugin) {
    var $e = plugin.e;

    $e.on('focus', '.filter-text input', function () {
        $(this).attr('placeholder', '');
        $(this).closest('.filter').addClass('filter-focus');
    }).on('blur', '.filter-text input', function () {
        $(this).attr('placeholder', $(this).attr('data-placeholder'));
        $(this).closest('.filter').removeClass('filter-focus');
    }).on('input', '.filter-text input', function () {
        if ($(this).val() === '') {
            $(this).closest('.filter').addClass('filter-empty');
        } else {
            $(this).closest('.filter').removeClass('filter-empty');
        }
    }).on('keydown', function (event) {
        if (event.which === 13) {
            if ($e.prop('tagName') === 'FORM') {
                $(this).closest('form').submit();
            } else {
                event.preventDefault();
            }
        }
    });

    $e.on('focus', '.filter-daterange input', function () {
        $(this).attr('placeholder', '');
        $(this).closest('.filter').addClass('filter-focus');
    }).on('blur', '.filter-daterange input', function () {
        $(this).attr('placeholder', $(this).attr('data-placeholder'));
        $(this).closest('.filter').removeClass('filter-focus');
    }).on('input', '.filter-daterange input', function () {
        if ($(this).val() === '') {
            $(this).closest('.filter').addClass('filter-empty');
        } else {
            $(this).closest('.filter').removeClass('filter-empty');
        }
    });

    $e.on('select2-focus', '.filter-select input[type="hidden"], .filter-select select', function () {
        $(this).closest('.filter').addClass('filter-focus');
        if ($(this).val() === '') {
            $(this).prev().find('.select2-chosen').text('');
        }
    }).on('select2-blur', '.filter-select input[type="hidden"], .filter-select select', function () {
        $(this).closest('.filter').removeClass('filter-focus');
    }).on('change', '.filter-select input[type="hidden"], .filter-select select', function () {
        if ($e.prop('tagName') === 'FORM') {
            $(this).closest('form').submit();
        }
        if ($(this).val() === '' || $(this).val() === null) {
            $(this).closest('.filter').addClass('filter-empty');
        } else {
            $(this).closest('.filter').removeClass('filter-empty');
        }
    });

    $e.on('click', '.input-clear-text', function ( ) {
        $(this).closest('.filter').addClass('filter-empty');
        var $input = $(this).parent().prev();
        // $input.val('').closest('form').submit();
        $input.val('').trigger('change.yiiGridView');
    });

    $e.on('click', '.input-clear-daterange', function () {
        $(this).closest('.filter').addClass('filter-empty');
        var $input = $(this).parent().prev();
        $input.data('daterangepicker').setStartDate('01/01/2013');
        $input.data('daterangepicker').setEndDate(window.moment().endOf('year').format('MM/DD/YYYY'));
        $input.val('').trigger('change.yiiGridView');
        app.grid.trigger($input.closest('form').data('name'), app.grid.UPDATE, {
            page: 1
        });
    });

    app.plugin.trigger(app.plugin.SEARCH_SELECT2_INIT);

    $e.each(function () {
        $(this).find('> .row:eq(0) > div:lt(4)').show();
        if ($(this).find('> .row:eq(0) > div').length > 4) {
            $(this).find('> .row:eq(1)').show();
        }
    });
    $e.find('.more').click(function () {
        $(this).hide().next().show().closest('.row').prev().find('> div').show();
    });
    $e.find('.less').click(function () {
        $(this).hide().prev().show().closest('.row').prev().find('> div:gt(3)').hide();
    });
});

app.plugin.on(app.plugin.SEARCH_SELECT2_INIT, function () {
    var pattern = new RegExp(/^<!--([A-Z]+)-->/),
        patternb = new RegExp(/<!--([A-Z]+)-->/),
        defaults = {
            allowClear: true,
            escapeMarkup: function (m) {
                var flag = false;
                if (m.substr(0, 4) === '<!--') {
                    var found = pattern.exec(m);
                    if (found && found.length >= 2) {
                        m = m.substr(found[0].length);
                        flag = found[1];
                    }
                }
                if (flag) {
                    m = '<span class="opt flagged flag-' + flag + '" data-bs-toggle="tooltip" data-bs-placement="right" title="' + flag + '">' + m + '</span>';
                } else if (m.length) {
                    m = '<span class="opt">' + m + '</span>';
                }
                return m;
            },
            formatResult: function (result, container, query, escapeMarkup) {
                return escapeMarkup(result.text);
            },
            width: '100%',
            matcher: function (term, text, pattern) {
                if (text.substr(0, 4) === '<!--') {
                    text = text.replace(pattern, '');
                }
                return text.toUpperCase().indexOf(term.toUpperCase()) >= 0;
            },
        };
    $('.search').each(function () {
       $(this).find('.filter-select input[type="hidden"], .filter-select select').each(function () {
            if (typeof $(this).data('select2') === 'undefined') {
                if ($(this).is('select')) {
                    $(this).select2($.extend(true, {}, defaults, $(this).data()));
                }
                $(this).closest('.filter-select').css('visibility', 'visible');
                if (patternb.exec($(this).text())) {
                    // This select includes hidden fields, add the "Show All" switch.
                    $(this).data('select2').dropdown
                        .addClass('show-all-added')
                        .append(
                            '<div class="select2-show-all">\n' +
                            '  <div class="form-check form-switch">\n' +
                            '    <input class="form-check-input" role="switch" type="checkbox">\n' +
                            '    <label class="form-check-label">Show All</label>\n' +
                            '  </div>\n' +
                            '</div>'
                        )
                        .find('.select2-show-all:first')
                        .on('click', function (event) {
                            var $checkbox = $(this).find(':checkbox');
                            var isChecked = $checkbox.is(':checked');
                            setTimeout(function () {
                                $checkbox.prop('checked', $(event.target).is($checkbox) ? isChecked : !isChecked);
                            }.bind(this), 0);
                            $(this).closest('.select2-drop').toggleClass('show-all');
                        });
                }
            }
        });
    });
});

$(function () {
    $('.search').each(function () {
        app.plugin.trigger(app.plugin.SEARCH_INIT, {
            e: $(this)
        });
    });
});

app.plugin.on(app.plugin.SELECT2_INIT, function () {
    var pattern = new RegExp(/^<!--([A-Z]+)-->/),
        patternb = new RegExp(/<!--([A-Z]+)-->/),
        defaults = {
            allowClear: true,
            escapeMarkup: function (m) {
                var flag = false;
                if (m.substr(0, 4) === '<!--') {
                    var found = pattern.exec(m);
                    if (found && found.length >= 2) {
                        m = m.substr(found[0].length);
                        flag = found[1];
                    }
                }
                if (flag) {
                    m = '<span class="opt flagged flag-' + flag + '" data-bs-toggle="tooltip" data-bs-placement="right" title="' + flag + '">' + m + '</span>';
                } else if (m.length) {
                    m = '<span class="opt">' + m + '</span>';
                }
                return m;
            },
            formatResult: function (result, container, query, escapeMarkup) {
                return escapeMarkup(result.text);
            },
            width: 'off',
            matcher: function (term, text, pattern) {
                if (text.substr(0, 4) === '<!--') {
                    text = text.replace(pattern, '');
                }
                return text.toUpperCase().indexOf(term.toUpperCase()) >= 0;
            },
        };
    $('input.select2').each(function () {
        if (typeof $(this).data('select2') === 'undefined') {
            var multiple = typeof $(this).data('multiple') !== 'undefined' ? $(this).data('multiple') : true;
            $(this).select2({
                separator: $(this).data('separator') || "\n",
                multiple: multiple,
            });
            // Select2 doesn't behave nicely when tags are enabled with multiple=false, showing "undefined"
            // even if value is set. This hacky workaround fixes it.
            if (!multiple) {
                var value = $(this).val();
                $(this).select2('val', value).val(value).prev().find('.select2-choice').removeClass('select2-default');
            }
        }
    });
    $('select.select2').each(function () {
        if (typeof $(this).data('select2') === 'undefined') {
            $(this).select2($.extend(true, {}, defaults, $(this).data()));
            if (patternb.exec($(this).text())) {
                // This select includes hidden fields, add the "Show All" switch.
                $(this).data('select2').dropdown
                    .addClass('show-all-added')
                    .append(
                        '<div class="select2-show-all">\n' +
                        '  <div class="form-check form-switch">\n' +
                        '    <input class="form-check-input" role="switch" type="checkbox">\n' +
                        '    <label class="form-check-label">Show All</label>\n' +
                        '  </div>\n' +
                        '</div>'
                    )
                    .find('.select2-show-all:first')
                    .on('click', function (event) {
                        var $checkbox = $(this).find(':checkbox');
                        var isChecked = $checkbox.is(':checked');
                        setTimeout(function () {
                            $checkbox.prop('checked', $(event.target).is($checkbox) ? isChecked : !isChecked);
                        }.bind(this), 0);
                        $(this).closest('.select2-drop').toggleClass('show-all');
                    });
            }
        }
    });
});

app.plugin.on(app.plugin.TEXTCOMPLETE_INIT, function () {
    $('.textcomplete').each(function () {
        var e = $(this);
        if (e.data('textComplete')) {
            return;
        } else {
            e.on('keyup', function (event) {
                if (event.which === 9 || event.which === 13) {
                    app.plugin.trigger(app.plugin.AUTOSIZE_UPDATE, {
                        e: e
                    });
                }
            });
        }
        var strategies = [];
        if (e.data('textcomplete')) {
            strategies.push({
                words: e.data('textcomplete'),
                match: /(\w+(?:\([^)]*\)?)?[.]*\w*[.]*(?:\([^)]*\)?)?)$/,
                search: function (term, callback) {
                    callback($.map(this.words || [], function (word) {
                        return -1 !== word.indexOf(term) ? word : null;
                    }));
                },
                replace: function (word) {
                    return word;
                },
                index: 1,
                template: function (value, term) {
                    return value.replace(term, '<b>' + term + '</b>');
                }
            });
        }
        if (e.data('textcomplete-square') || e.data('textcomplete-double-square')) {
            strategies.push({
                match: /\[([\[\w.]*)$/,
                search: function (term, callback) {
                    this.braces = ['[', ']'];
                    if (term.charAt(0) === '[') {
                        term = term.substr(1);
                        this.braces = ['[[', ']]'];
                    }
                    var words = e.data('textcomplete-' + (this.braces[0] === '[' ? 'square' : 'double-square'));
                    callback($.map(words || [], function (word) {
                        return -1 !== word.indexOf(term) ? word : null;
                    }));
                },
                replace: function (word) {
                    return this.braces[0] + word + this.braces[1];
                },
                index: 1,
                template: function (value, term) {
                    if (term.charAt(0) === '[') {
                        term = term.substr(1);
                    }
                    return this.braces[0] + value.replace(term, '<b>' + term + '</b>') + this.braces[1];
                }
            });
        }
        if (e.data('textcomplete-curly')) {
            strategies.push({
                words: e.data('textcomplete-curly'),
                match: /\{([{\w]*)$/,
                search: function (term, callback) {
                    if (term.charAt(0) === '{') {
                        callback([]);
                    } else {
                        callback($.map(this.words || [], function (word) {
                            return -1 !== word.indexOf(term) ? word : null;
                        }));
                    }
                },
                replace: function (word) {
                    return '{' + word + '}';
                },
                index: 1,
                template: function (value, term) {
                    return '{' + value.replace(term, '<b>' + term + '</b>') + '}';
                }
            });
        }
        if (e.data('textcomplete-double-curly')) {
            strategies.push({
                words: e.data('textcomplete-double-curly'),
                match: /(\w+(?:\([^)]*\)?)?[.]*\w*[.]*(?:\([^)]*\)?)?)$/,
                search: function (term, callback) {
                    var val = $(e).val();
                    for (var i = e.caret('pos'); i >= 0; i--) {
                        if (val[i] === '}' && val[i - 1] === '}') {
                            callback([]);
                            return;
                        }
                        if (val[i] === '{' && val[i - 1] === '{') {
                            callback($.map(this.words || [], function (word) {
                                return -1 !== word.indexOf(term) ? word : null;
                            }));
                            return;
                        }
                    }
                    callback([]);
                },
                replace: function (word) {
                    return word;
                },
                index: 1,
                template: function (value, term) {
                    return value.replace(term, '<b>' + term + '</b>');
                }
            });
        }
        e.textcomplete(strategies, {
            appendTo: $(e.data('textcomplete-append-to') || 'body'),
            maxCount: e.data('textcomplete-max-count') || 100,
            placement: e.data('textcomplete-placement') || 'bottom',
            className: e.data('textcomplete-class-name') || ''
        });
    });
});

app.plugin.on(app.plugin.TYPEAHEAD_JS_INIT, function () {
    if (typeof $.fn.typeahead === 'function') {
        $('.typeahead').each(function () {
            var source = $(this).data('typeahead-source');
            if (source.length) {
                $(this).typeahead({
                    minLength: 0
                }, {
                    limit: 100,
                    source: function (q, sync) {
                        var bloodhound = new Bloodhound({
                            datumTokenizer: Bloodhound.tokenizers.whitespace,
                            queryTokenizer: Bloodhound.tokenizers.whitespace,
                            local: source
                        });
                        if (q === '') {
                            sync(source);
                        } else {
                            bloodhound.search(q, sync);
                        }
                    }
                });
            }
        });
    }
});

app.plugin.on(app.plugin.UI_BLOCK, function (plugin) {
    plugin.e.block({
        message: '<div role="status" class="spinner-border text-info avatar-md"></div>',
        css: { backgroundColor: 'none', border: 'none' },
        overlayCSS: { opacity: 0.1 }
    });
});

app.plugin.on(app.plugin.UI_UNBLOCK, function (plugin) {
    plugin.e.unblock();
});
